import './styles/ViewfinderFrame.css';

const CORNERS = ['top-left', 'top-right', 'bottom-left', 'bottom-right'];

export default function ViewfinderFrame({ className = '' }) {
    return (
        <div className={`viewfinder-frame ${className}`.trim()} aria-hidden="true">
            {CORNERS.map(corner => (
                <span key={corner} className={`viewfinder-frame__corner viewfinder-frame__corner--${corner}`} />
            ))}
        </div>
    );
}
